<template>
  <BaseLayout>
    <template v-slot:top_buttons>
      <div v-if="activeTab === 'stores'" v-click-outside="closeAddButtons">
        <button type="button" class="btn btn-primary" @click="showAddButtons = !showAddButtons">
          Добавить магазин
        </button>
        <div class="dropdown-menu" aria-labelledby="btnGroupDrop1" :class="showAddButtons ? 'show' : ''">
          <a class="dropdown-item" href="javascript:void(0);" @click="createStore('ozon')">Озон</a>
          <a class="dropdown-item" href="javascript:void(0);" @click="createStore('wb')">Wildberries</a>
          <a class="dropdown-item" href="javascript:void(0);" @click="createStore('yandex')">Яндекс Маркет</a>
        </div>
      </div>
    </template>

    <ul class="nav nav-pills flex-column flex-sm-row mb-4">
      <li class="nav-item">
        <a class="nav-link" :class="activeTab === 'stores' ? 'active' : ''" href="javascript:void(0);"
           @click="activeTab = 'stores'">Магазины</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" :class="activeTab === 'update' ? 'active' : ''" href="javascript:void(0);"
           @click="activeTab = 'update'">Обновление справочников</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" :class="activeTab === 'offer-tasks' ? 'active' : ''" href="javascript:void(0);"
           @click="activeTab = 'offer-tasks'">Задачи с товарами</a>
      </li>
    </ul>

    <div v-show="activeTab === 'stores'">
      <BaseModal ref="storeModal" :modal-title="modalTitle">
        <component v-if="marketplace_form" :is="marketplace_form" v-bind="marketplace_props"
                   @store-success="storeSuccess"
                   ref="MarketPlaceForm"></component>
      </BaseModal>

      <LoadingBlock :loading="loadingStores">
        <div class="row mb-12 g-6">
          <div class="col-md-6 col-lg-4" v-for="(store, index) in stores" :key="index">
            <div class="card">
              <div class="card-body">
                <h5 class="card-title">{{ store.name }}</h5>
                <p class="card-text">Маркетплейс: {{ marketplaces[store.marketplace].title }}</p>
                <div class="demo-inline-spacing">
                  <button class="btn btn-outline-secondary waves-effect" @click="editStore(store.marketplace, store.id)">
                    Редактировать
                  </button>
                </div>
                <div class="demo-inline-spacing">
                  <ButtonComponent :ref="'deleteStoreButton'+index" :class="'btn btn-outline-danger waves-effect'"
                                   @click="deleteStore(store.id, 'deleteStoreButton'+index)">Удалить
                  </ButtonComponent>

                  <ButtonComponent :ref="'getOffersButton'+index" :class="'btn btn-outline-secondary waves-effect'"
                                   @click="storeGetOffers(store.id, 'getOffersButton'+index)">Обновить товары
                  </ButtonComponent>

                </div>
              </div>
            </div>
          </div>
        </div>
      </LoadingBlock>
    </div>

    <div v-show="activeTab === 'update'">
      <MarketplaceInfoUpdate :stores="stores"/>
    </div>

    <div v-show="activeTab === 'offer-tasks'">
      <StoreOfferTasks :stores="stores"/>
    </div>
  </BaseLayout>
</template>

<script>
import BaseLayout from "@/layouts/Base.vue";
import {PageInfo} from "@/data/page";
import {user} from "@/data/user";
import {
  deleteStore,
  getStoreOzone,
  getStores,
  getStoreWb,
  importProducts,
  getOffers,
  getStoreYandex,
  getOrders
} from "@/api/store";
import {VOnClickOutside as ClickOutside} from "@/helpers/directives/clickOutside"
import BaseModal from "@/components/Modal.vue";
import OzonForm from "@/components/forms/Ozon.vue";
import WbForm from "@/components/forms/Wb.vue";
import YandexForm from "@/components/forms/Yandex.vue";
import {shallowRef} from "vue";
import ButtonComponent from "@/components/tools/Button.vue";
import LoadingBlock from "@/components/page/LoadingBlock.vue";
import {afterStoreAction} from "@/helpers/store";
import {stores} from "@/data/store";
import MarketplaceInfoUpdate from "@/components/store/MarketplaceInfoUpdate.vue";
import StoreOfferTasks from "@/components/store/StoreOfferTasks.vue";

const marketplaces = {
  ozon: {
    form: OzonForm,
    api: getStoreOzone,
    title: 'Озон'
  },
  wb: {
    form: WbForm,
    api: getStoreWb,
    title: 'Wildberries'
  },
  yandex: {
    form: YandexForm,
    api: getStoreYandex,
    title: 'Яндекс Маркет'
  }
}

export default {
  name: 'StoresView',
  components: {StoreOfferTasks, MarketplaceInfoUpdate, LoadingBlock, ButtonComponent, BaseModal, BaseLayout},
  data() {
    return {
      activeTab: 'stores',
      showAddButtons: false,
      stores: [],
      marketplace_form: '',
      marketplace_props: {},
      modalTitle: 'Новый магазин',
      marketplaces: marketplaces,
      loadingStores: true
    }
  },
  directives: {
    ClickOutside
  },
  methods: {
    closeAddButtons() {
      this.showAddButtons = false
    },
    async createStore(marketplace) {
      this.marketplace_form = ''
      this.modalTitle = 'Новый магазин'
      setTimeout(() => {
        this.$refs.storeModal.openModal()
        this.marketplace_props = {'item': ''}
        this.marketplace_form = shallowRef(marketplaces[marketplace].form)
      }, 100)
    },
    async editStore(marketplace, store_id) {
      this.marketplace_form = ''
      this.modalTitle = 'Редактировать магазин'
      setTimeout(async () => {
        this.$refs.storeModal.openModal()
        const result = await marketplaces[marketplace].api(store_id)
        this.marketplace_props = {'item': result.data}
        this.marketplace_form = shallowRef(marketplaces[marketplace].form)
      })
    },
    async deleteStore(store_id, button) {
      if (confirm('Вы уверены, что хотите удалить магазин?')) {
        this.$refs[button][0].startLoading()
        await deleteStore(store_id)
        this.$refs[button][0].endLoading()
        await this.updateStores()
        stores.resetStores()
      }
    },
    async storeImport(store_id, button) {
      if (confirm('Вы уверены, что хотите импортировать товары из магазина?')) {
        this.$refs[button][0].startLoading()
        try {
          const result = await importProducts(store_id)
          afterStoreAction(result)
        } catch (exception){
          afterStoreAction(exception.response)
        }
        this.$refs[button][0].endLoading()
      }
    },
    async storeGetOffers(store_id, button) {
      if (confirm('Вы уверены, что хотите обновить цены?')) {
        this.$refs[button][0].startLoading()
        try {
          const result = await getOffers(store_id)
          afterStoreAction(result)
        } catch (exception){
          afterStoreAction(exception.response)
        }
        this.$refs[button][0].endLoading()
      }
    },
    async storeGetOrders(store_id, button) {
      if (confirm('Вы уверены, что хотите загрузить заказы?')) {
        this.$refs[button][0].startLoading()
        try {
          const result = await getOrders(store_id)
          afterStoreAction(result)
        } catch (exception){
          afterStoreAction(exception.response)
        }
        this.$refs[button][0].endLoading()
      }
    },
    async updateStores() {
      this.loadingStores = true
      const active_company = await user.getActiveCompany()
      const result = await getStores(active_company, 1, 10000)
      this.stores = result.data.items
      this.loadingStores = false
    },
    async storeSuccess() {
      this.$refs.storeModal.closeModal()
      await this.updateStores()
      await stores.updateStores()
    }
  },
  async mounted() {
    PageInfo.title = 'Магазины'
    PageInfo.breadcrumbs = [
      {
        title: 'Главная',
        link: '/'
      },
      {
        title: PageInfo.title
      }
    ]
    await user.getUserBase()
    await this.updateStores()
  }
}
</script>